<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
let api_url = process.env.VUE_APP_API_URL;
let my_liff_id = process.env.VUE_APP_LIFF_ID;
let isVConsole = process.env.VUE_APP_VCONSOLE;
let params = new URLSearchParams(window.location.search.substring(1));

if (isVConsole == '1' || params.get('vconsole') == '1') {
    let vConsoleScript = document.createElement('script');
    vConsoleScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/vConsole/3.4.0/vconsole.min.js');
    document.head.appendChild(vConsoleScript);

    vConsoleScript.onload = function () {
        var vConsole = new VConsole();
    };
}

export default {
  data() {
    return {
      // userId: null,
    };
  },
  created() {
    console.log("at created first");
    // this.$liff
    //   .init({ liffId: my_liff_id })
    //   .then(() => {
    //     // success

    //     if (!this.$liff.isLoggedIn()) {
    //       this.$liff.login({ redirectUri: window.location });
    //     }
    //     const context = this.$liff.getContext();
    //     console.log(context);
    //     console.log(context.userId);
    //     // this.userId  = context.userId;
    //     this.$store.commit("setUserId", context.userId);
    //   })
    //   .catch(err => {
    //     alert("in created");
    //     console.log(err);
    //     alert(err);
    //   });
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
